import { Feature } from '@reliance/types/enums/Feature';
import { Facility } from '@reliance/types/models/Facility';

/**
 * Normalize facility feature values from the API or form state. The API could potentially
 * return an array of features or a single, non-decoded, feature string.
 */
function normalizeFacilityFeatures(features: unknown): string[] {
  if (features == null) {
    return [];
  }
  if (Array.isArray(features)) {
    return features as string[];
  }
  if (typeof features === 'string') {
    return JSON.parse(features) as string[];
  }
  return [];
}

/**
 * True when the facility has the given feature enabled.
 * Accepts null/undefined facility and API feature shapes (array or single string).
 */
export function facilityHasFeature(
  facility: Pick<Facility, 'features'> | null | undefined,
  feature: Feature | string
): boolean {
  if (facility == null) {
    return false;
  }
  return normalizeFacilityFeatures(facility.features).includes(feature);
}

/**
 * Feature list for facility edit form state (checkbox Field values).
 * Prefer {@link facilityHasFeature} when checking a loaded facility.
 */
export function getFacilityFeatureList(features: unknown): string[] {
  return normalizeFacilityFeatures(features);
}
